export default __webpack_public_path__ + "static/media/Mark-6-HUD-3D (Environmental Scan).027ea7a0.jpg";